import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  padding: 16px 24px;
  box-shadow: 0px 1px 0px ${({ theme }) => theme.colors.grey000};
  box-sizing: border-box;
`;

export const UserNameWrapper = styled.div`
  position: relative;
  margin-inline-start: auto;
  cursor: pointer;
`;

export const UserName = styled(typography.P2RegularTypography)`
  display: flex;
  min-width: 150px;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};

  &:after {
    content: '\\e901';
    font-family: 'Icomoon';
    font-size: 8px;
    margin-inline-start: 6px;
  }
`;

export const LogoutPopup = styled.div`
  position: absolute;
  top: 25px;
  width: 100%;
  padding: 4px 0;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-shadow: 0px 4px 16px rgb(0 0 0 / 16%);
  z-index: 1;
`;

export const Logout = styled(typography.P2RegularTypography)`
  margin: 0;
  padding: 6px 16px;
  color: ${({ theme }) => theme.colors.black};

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey100};
  }
`;

export const UserNameLoaderWrapper = styled.div`
  margin-inline-start: auto;
`;
